import { isDefinedString } from "et3-type-guards";

import ET3Div from "../et3-div";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import Et3Text from "../et3-text";
import {
  SURFACE_BORDER,
  SURFACE_HEADER_BACKGROUND,
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../et3-theme/surface-constants";
import {
  SECTION_BODY_PADDING,
  SECTION_HEADER_HEIGHT,
  SECTION_HEADER_PADDING,
  SECTION_TITLE_FONT_SIZE
} from "./section-constants";

const Et3Card = withLiteObserverAndTheme<{
  children?: React.ReactNode;
  title: string;
  withBodyPadding: boolean;
}>((props) => {
  const { children = null, title, withBodyPadding, theme } = props;
  const { colors, unitX, unitY } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.white}
      style={{
        boxSizing: "border-box",
        width: "100%",
        minWidth: 0,
        border: SURFACE_BORDER,
        borderRadius: SURFACE_RADIUS_CSS,
        boxShadow: SURFACE_SHADOW,
        overflow: "hidden"
      }}
      onClick={() => {}}
    >
      {isDefinedString(title) ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={0}
          height={SECTION_HEADER_HEIGHT}
          fDirection="row"
          alignItems="center"
          justifyContent="flex-start"
          color={SURFACE_HEADER_BACKGROUND}
          style={{
            boxSizing: "border-box",
            width: "100%",
            paddingLeft: SECTION_HEADER_PADDING * unitX,
            paddingRight: SECTION_HEADER_PADDING * unitX,
            borderBottom: SURFACE_BORDER
          }}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={SECTION_TITLE_FONT_SIZE}
            text={title}
            isSpan={true}
            color={colors.all.maastrichtBlue}
            style={{ margin: 0 }}
          />
        </ET3Div>
      ) : null}
      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={false}
        width={0}
        height={0}
        fDirection="column"
        alignItems="stretch"
        justifyContent="flex-start"
        color={colors.all.white}
        style={{
          boxSizing: "border-box",
          width: "100%",
          padding: withBodyPadding
            ? `${SECTION_BODY_PADDING * unitY}px ${SECTION_BODY_PADDING * unitX}px`
            : 0
        }}
        onClick={() => {}}
      >
        {children}
      </ET3Div>
    </ET3Div>
  );
});
export default Et3Card;
